import React, { useEffect, useState } from 'react';
import { Search, Trash2, PlusCircle, List, Download } from 'lucide-react'; // Using lucide for icons
import '../Style/Component/AnnouncementCom.css';
import { getWithTokenAPI, postWithTokenAPI } from '../Util/Api';
import { useSelector } from "react-redux";
import Select from 'react-select';
const AnnouncementCom = () => {
    const [activeTab, setActiveTab] = useState('listing');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [target, setTarget] = useState('customer');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterTarget, setFilterTarget] = useState('all');
    const [page, setPage] = useState(1);
    const itemsPerPage = 10;

    const [announcements, setAnnouncements] = useState([]);
    const auth = useSelector((state) => state.auth);
    const token = auth.token;

    const filterOptions = [
        { value: 'all', label: 'Status: All' },
        { value: 'customer', label: 'Customer' },
        { value: 'driver', label: 'Driver' },
    ];

    const customStyles = {
        control: (base, state) => ({
            ...base,
            backgroundColor: "#f8f9fc", // Light gray background from your screenshot
            borderColor: state.isFocused ? "#cbd5e1" : "#e2e8f0",
            borderRadius: "10px", // Soft rounded corners
            minHeight: "40px",
            width: "180px",
            boxShadow: "none",
            fontSize: "14px",
            cursor: "pointer",
            transition: "all 0.2s ease",
            "&:hover": {
                borderColor: "#cbd5e1",
            },
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "0 12px",
        }),
        indicatorSeparator: () => ({
            display: "none", // Line-ah remove panna clean-ah irukkum
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: "#94a3b8",
            padding: "0 8px",
        }),
        singleValue: (base) => ({
            ...base,
            color: "#1e293b",
            fontWeight: "500",
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "10px",
            marginTop: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", // Floating effect
            border: "1px solid #e2e8f0",
            overflow: "hidden",
        }),
        option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected
                ? "#3b82f6"
                : isFocused
                    ? "#f1f5f9"
                    : "white",
            color: isSelected ? "white" : "#475569",
            fontSize: "14px",
            cursor: "pointer",
            "&:active": {
                backgroundColor: "#cbd5e1",
            },
        }),
    };


    const fetchbannerdetails = async () => {
        try {
            const response = await getWithTokenAPI(
                token,
                `/announcement/list`
            );
            const formattedData = response?.data?.map((item) => ({
                id: item._id,
                title: item.title,
                description: item.description,
                target:
                    item.userId?.length > 0
                        ? "customer"
                        : item.driverId?.length > 0
                            ? "driver"
                            : "",
            }));
            setAnnouncements(formattedData);

        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        fetchbannerdetails()
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title.trim() || !description.trim()) return;

        try {
            let payload = {
                title: title,
                description: description,
            };

            if (target === "customer") {
                payload.userId = "all";
            } else {
                payload.driverId = "all";
            }

            const res = await postWithTokenAPI(
                token,
                "/announcement/create",
                payload
            );

            console.log("Announcement Response:", res);

            if (res?.statusCode === 200) {
                setTitle("");
                setDescription("");
                setTarget("customer");
                setActiveTab("listing");
            }

        } catch (error) {
            console.error("Announcement Error:", error);
        }
    };

    const filteredAnnouncements = announcements.filter((item) => {
        const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.description.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesTarget = filterTarget === 'all' || item.target === filterTarget;
        return matchesSearch && matchesTarget;
    });

    const tpage = Math.ceil(filteredAnnouncements.length / itemsPerPage);
    const paginatedAnnouncements = filteredAnnouncements.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    useEffect(() => {
        setPage(1);
    }, [searchTerm, filterTarget]);

    return (
        <div className="modern-container">
            {/* Dark Header inspired by screenshot */}
            <header className="page-header">
                <h1>Announcement Management</h1>
                <div className="header-controls">
                    <div className="search-wrapper">
                        <Search size={18} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Search announcements..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="filter-wrapper" style={{ display: 'flex', alignItems: 'center', background: 'transparent', border: 'none' }}>
                        <Select
                            value={filterOptions.find(opt => opt.value === filterTarget)}
                            onChange={(selected) => setFilterTarget(selected.value)}
                            options={filterOptions}
                            styles={customStyles}
                            isSearchable={false}
                        />
                    </div>
                </div>
            </header>

            {/* Tabs */}
            <div className="tab-navigation">
                <button className={activeTab === 'listing' ? 'active' : ''} onClick={() => setActiveTab('listing')}>
                    <List size={18} /> Listing
                </button>
                <button className={activeTab === 'create' ? 'active' : ''} onClick={() => setActiveTab('create')}>
                    <PlusCircle size={18} /> Create New
                </button>
            </div>

            <main className="content-area">
                {activeTab === 'create' ? (
                    <div className="form-card animate-fade-in">
                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <label className="field-label">Announcement Title</label>
                                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter Title" required />
                            </div>
                            <div className="input-group">
                                <label className="field-label">Description</label>
                                <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Enter details" required />
                            </div>
                            <div >
                                <label className="field-label">Target Audience</label>
                                <div className="segmented-control">
                                    <input
                                        type="radio"
                                        id="customer"
                                        name="target"
                                        value="customer"
                                        checked={target === 'customer'}
                                        onChange={(e) => setTarget(e.target.value)}
                                    />
                                    <label htmlFor="customer" className="segment">Customer</label>

                                    <input
                                        type="radio"
                                        id="driver"
                                        name="target"
                                        value="driver"
                                        checked={target === 'driver'}
                                        onChange={(e) => setTarget(e.target.value)}
                                    />
                                    <label htmlFor="driver" className="segment">Driver</label>

                                    {/* This div creates the sliding background effect */}
                                    <div className={`selection-slider ${target}`}></div>
                                </div>
                            </div>
                            <button type="submit" className="btn-save">Publish</button>
                        </form>
                    </div>
                ) : (
                    <div className="table-wrapper animate-fade-in">
                        <table className="modern-table">
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Title</th>
                                    <th>Description</th>
                                    <th>Target</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedAnnouncements.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="font-bold">{index + 1}</td>

                                        <td className="font-bold">{item.title}</td>
                                        <td >{item.description}</td>
                                        <td>
                                            <span className={`badge badge-${item.target}`}>
                                                {item.target}
                                            </span>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="4">
                                        {tpage > 1 && (
                                            <div className="pagination">
                                                {page > 1 && (
                                                    <button
                                                        className="page-btn"
                                                        onClick={() => setPage((page) => page - 1)}
                                                    >
                                                        ‹
                                                    </button>
                                                )}
                                                {page > 1 && (
                                                    <button
                                                        className="page-btn"
                                                        onClick={() => setPage(1)}
                                                    >
                                                        1
                                                    </button>
                                                )}
                                                {page === tpage && tpage > 2 && (
                                                    <span className="page-dots">…</span>
                                                )}
                                                <button className="page-btn pgnoactive">
                                                    {page}
                                                </button>

                                                {page !== tpage && (
                                                    <span className="page-dots">…</span>
                                                )}

                                                {page !== tpage && (
                                                    <button
                                                        className="page-btn"
                                                        onClick={() => setPage(tpage)}
                                                    >
                                                        {tpage}
                                                    </button>
                                                )}

                                                {page < tpage && (
                                                    <button
                                                        className="page-btn"
                                                        onClick={() => setPage((page) => page + 1)}
                                                    >
                                                        ›
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                )}
            </main>
        </div>
    );
};

export default AnnouncementCom;